<div class="container-fluid backPink">
    <div class="row">
        <div class="col-sm-12 pt-5">
            <p class="text-center"><img src="/assets/image/inicio/d1.png" class="logoTitle" ><span class="title">Merchandising</span></p>
        </div>
        <div class="col-sm-2">

        </div>
        <div class="col-sm-8 text-center">
            <table class="w-100">
                <tr>
                    <td><a class="btn btn-seccion">Ver Todos →</a></td>
                   
                </tr>
            </table>
        </div>
        <div class="col-sm-2">

        </div>
        <div class="col-sm-12 mt-2">
            <div class="container-fluid">
                <div class="row">
                    <div class="col-sm-4" *ngFor="let item of listMerchadising.response.list | slice:0:6; let i=index">
                       
                        <div class="panelLib">
                            <div class="container-fluid"> 
                                <div class="row">
                                    <div class="col-sm-6">
                                        <img src="{{item.image}}" class="imgPreview">
                                    </div>
                                    <div class="col-sm-6">
                                        <p class="titulo">{{item.title}}</p>
                                        <p class="descripcion">{{item.subtitle}}</p>
                                        <p class="precio">S/ {{item.price}}</p>                                        
                                        <a class="btn btnDetalle" [routerLink]="['/detalleSourvenir/',item.id]">Ver Detalle</a><br/>
                                        <a class="btn btnComprar"  (click)="onComprar(item.id)">Comprar</a><br/>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-sm-12 mt-4 mb-5">
            <img class="desing" src="/assets/image/inicio/dis_fond_3.png">
        </div>
    </div>
</div>